// Query keys for a single generated report.
//
// The shape is EXACTLY `["report", id]` because it is not this file's key
// alone: ReportV32DetailPage and ReportViewerPage read the same tuple, and the
// editor's Save Draft / Re-generate invalidate it so those surfaces refresh.
// Changing the shape here silently un-links them — they would keep reading a
// cache nothing invalidates any more, which is precisely the stale-after-save
// class the gate exists to prevent.

export const reportEditorKeys = {
  /** Prefix over every generated-report read. */
  all: () => ["report"] as const,
  detail: (reportId: string) => ["report", reportId] as const,
};
